import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import useScorm from './hooks/useScorm';
import Resource from './components/Resource';
import './style';

const Prestage = ({ match, history }) => {
  const { params } = match;
  const { data, isError } = useScorm({ ...params, attempt: 1 });
  const pages = (!isError && data.short_name)
    ? Array.from(new Set([
      ...data.page.map(item => item.title_id).filter(item => item),
      data.cover,
    ]))
    : [];
  return (
    <div>
      {(!isError && data.short_name)
        ? (
          <Resource
            history={history}
            book={{
              stageId: params.stageId,
              stage: data.stage,
              id: params.id,
              attempt: data.attempt,
              name: data.short_name,
              size: data.size,
              pages: pages.join(','),
            }}
          />
        )
        : null
      }
    </div>
  );
};

Prestage.propTypes = {
  history: PropTypes.object,
  match: PropTypes.object,
};

export default withRouter(Prestage);
